import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SearchState {
  lastUpdated: number;
  searchData: any;
  isFilterApplied: boolean;
  liveSearchObject: any;
}

const initialState: SearchState = {
  lastUpdated: Date.now(),
  searchData: null,
  isFilterApplied: false,
  liveSearchObject: null,
};

const searchStateSlice = createSlice({
  name: "searchState",
  initialState,
  reducers: {
    updateSearchState: (state, action: PayloadAction<{ searchData: any }>) => {
      state.searchData = action.payload.searchData;
      state.lastUpdated = Date.now();
    },
    setIsFilterApplied: (state, action: PayloadAction<boolean>) => {
      state.isFilterApplied = action.payload;
    },
    setLiveSearchObject: (state, action: PayloadAction<any>) => {
      state.liveSearchObject = action.payload;
    },
  },
});

export const { updateSearchState, setIsFilterApplied, setLiveSearchObject } = searchStateSlice.actions;
export default searchStateSlice.reducer;
